import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Card, Result, Spin } from 'antd';
import UserService from '../../services/UserService';

const PaymentCallbackSuccess: React.FC = () => {
  const navigate = useNavigate();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  useEffect(() => {
    const isAiCreditPayment = localStorage.getItem('sahaPaymentDestination') === 'ai-credit';
    if (isAiCreditPayment) {
      UserService.getMe()
        .then((response: any) => {
          localStorage.setItem('aiChatCredit', String(response.data?.aiChatCredit ?? 0));
        })
        .catch(() => undefined);
    }
    setTimeout(() => {
      localStorage.removeItem('sahaPaymentDestination');
      localStorage.removeItem('sahaAiCreditPurchaseId');
      navigate(isAiCreditPayment ? '/ai-assistant' : '/my-course');
    }, 3000);
  }, [navigate])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Card style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
      <Result
        status="success"
        title="Ödeme Başarılı"
        subTitle="Ödemeniz alındı. Yönlendiriliyorsunuz."
      />
      <Spin indicator={antIcon} style={{ marginTop: 16 }} />
    </Card>
  </div>
  );
};

export default PaymentCallbackSuccess;
